import React, { useState, useEffect, useRef } from "react";

import "../css/PopupHoursEdition.css";

import InputData from "../../components/InputData";
import ButtonIconH from "../../components/ButtonIconH";
import { post } from "../../js/post";
import { userData } from "../../js/utils";

export default ({
  show,
  idRegistro,
  agente,
  inicioOriginal,
  finOriginal,
  onCancel,
  onAccept,
  createPopupQuestion,
  removePopupQuestion,
}) => {
  const [inicioCorregido, setInicioCorregido] = useState("");
  const [finCorregido, setFinCorregido] = useState("");
  const [correctingRecord, setCorrectingRecord] = useState(false);
  const inicioCorregidoRef = useRef(null);
  const finCorregidoRef = useRef(null);

  const cancel = () => {
    onCancel();
  };

  const solicitarCorreccion = async () => {
    if (!inicioCorregido || !finCorregido) {
      createPopupQuestion(
        "Debe introducir una hora correcta.",
        removePopupQuestion,
        null,
        "Entendido",
      );
      return;
    }

    if (finCorregido <= inicioCorregido) {
      createPopupQuestion(
        "La hora de fin debe ser mayor a la hora de inicio.",
        removePopupQuestion,
        null,
        "Entendido",
      );
      return;
    }

    setCorrectingRecord(true);
    await post("CorregirRegistroJornada.php", {
      token: userData.token,
      idRegistro,
      horaInicio: `${inicioCorregido}:00`,
      horaFin: `${finCorregido}:00`,
    });
    setCorrectingRecord(false);

    createPopupQuestion(
      "Solicitud enviada correctamente.",
      () => {
        removePopupQuestion();
        onCancel();
        onAccept();
      },
      null,
      "Entendido",
    );
  };

  useEffect(() => {
    if (show) {
      setInicioCorregido("");
      setFinCorregido("");
      setTimeout(() => {
        inicioCorregidoRef.current?.focus();
      }, 0);
    }
  }, [show]);

  return show ? (
    <div className="popup-container popup-normal popup-hoursedition">
      <div className="popup-message">
        <div className="popup-header">
          <div className="popup-title">Corrección de registro de jornada</div>
          <img
            src="/images/close-white.svg"
            loading="lazy"
            alt=""
            className="popup-close"
            onClick={cancel}
          />
        </div>
        <div className="popup-body">
          <div className="popup-body-hoursedition">
            <div className="popup-hoursedition-contenido-element">
              <div className="label hoursedition-popup-label">Agente</div>
              <span>{agente}</span>
            </div>
            <div className="popup-hoursedition-contenido-element hoursedition-time-header-row">
              <div className="label hoursedition-popup-label"></div>
              <span className="hoursedition-time-header">Inicio</span>
              <span className="hoursedition-time-separator"></span>
              <span className="hoursedition-time-header">Fin</span>
            </div>
            <div className="popup-hoursedition-contenido-element">
              <div className="label hoursedition-popup-label">
                Registro original
              </div>
              <InputData
                inactive={true}
                size={4}
                extra="hoursedition-time-input"
                forceCenter={true}
                input={inicioOriginal}
                onChange={() => {}}
              />
              <span className="hoursedition-time-separator">a</span>
              <InputData
                inactive={true}
                size={4}
                extra="hoursedition-time-input"
                forceCenter={true}
                input={finOriginal}
                onChange={() => {}}
              />
            </div>
            <div className="popup-hoursedition-contenido-element">
              <div className="label hoursedition-popup-label">
                Registro corregido
              </div>
              <input
                ref={inicioCorregidoRef}
                type="time"
                className="input-field hoursedition-time-input"
                value={inicioCorregido}
                onChange={(e) => setInicioCorregido(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    finCorregidoRef.current?.focus();
                  }
                }}
              />
              <span className="hoursedition-time-separator">a</span>
              <input
                ref={finCorregidoRef}
                type="time"
                className="input-field hoursedition-time-input"
                value={finCorregido}
                onChange={(e) => setFinCorregido(e.target.value)}
              />
            </div>
          </div>
        </div>
        <div className="popup-footer">
          <div className="popup-row-buttons">
            <ButtonIconH
              text="Solicitar corrección"
              disabled={correctingRecord}
              onClick={solicitarCorreccion}
            />
            <ButtonIconH text="Cancelar" onClick={cancel} />
          </div>
        </div>
      </div>
    </div>
  ) : null;
};
